import React, { Component } from 'react';
import { message } from 'antd';
import TableC from '../../basicElement/TableC';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import ExportUtil from '../../../common/ExportUtil';
import format from '../../shared/format';
import SideNav from '../SideNav';
import Filter from './Filter';
import { Default, JdeApplyStatus } from '../ApplyJdeCode/constants';
import '../style.less';

// CRM合同生成的JDE建号申请状态包含 助理审批(ASSISTANT_APPROVAL)，共享常量中不存在，这里补充
const CrmJdeApplyStatus = {
    ASSISTANT_APPROVAL: '待助理审批',
    ...JdeApplyStatus,
};

class CrmContractRecord extends Component {
    state = {
        loading: false,
        sortParams: {},
        searchParams: {},
        pagination: {
            pageSize: 20,
            current: 1,
        },
        data: [],
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { sortParams, searchParams, pagination, pagination: { current, pageSize } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.queryCrmContractList,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
                ...sortParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = params => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            searchParams: { ...params },
            pagination,
        }, () => {
            this.loadData();
        });
    }

    // 0/1 -> 是/否
    renderDefault = text => Default[text] || ''

    // 兼容后端返回枚举值或中文
    renderJdeApplyStatus = text => text ? (CrmJdeApplyStatus[text] || text) : ''

    getColumns = () => [{
        title: '需求ID',
        dataIndex: 'crmRequirementId',
        key: 'crmRequirementId',
        fixed: 'left',
        width: 120,
    }, {
        title: '业务机会编号',
        dataIndex: 'businessOpportunityNum',
        key: 'businessOpportunityNum',
        fixed: 'left',
        width: 120,
    }, {
        title: '合同类型',
        dataIndex: 'contractTypeValue',
        key: 'contractTypeValue',
        width: 100,
    }, {
        title: '我方签署单位',
        dataIndex: 'signingUnit',
        key: 'signingUnit',
        width: 160,
    }, {
        title: '合同签署方',
        dataIndex: 'contractSigningUnit',
        key: 'contractSigningUnit',
        width: 160,
    }, {
        title: '客户项目号',
        dataIndex: 'customerProjectCode',
        key: 'customerProjectCode',
        width: 120,
    }, {
        title: '报价金额',
        dataIndex: 'quotationAmount',
        key: 'quotationAmount',
        width: 110,
        render: text => format('money', text),
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusiness',
        key: 'lineOfBusiness',
        width: 100,
    }, {
        title: '项目领域',
        dataIndex: 'investigationAreaName',
        key: 'investigationAreaName',
        width: 120,
    }, {
        title: '项目适应症',
        dataIndex: 'diseaseName',
        key: 'diseaseName',
        width: 120,
    }, {
        title: '合同开始日期',
        dataIndex: 'contractBeginDateShow',
        key: 'contractBeginDateShow',
        width: 110,
    }, {
        title: '合同结束日期',
        dataIndex: 'contractEndDateShow',
        key: 'contractEndDateShow',
        width: 110,
    }, {
        title: '是否提前上岗',
        dataIndex: 'advanceDuty',
        key: 'advanceDuty',
        width: 100,
        render: text => this.renderDefault(text),
    }, {
        title: '主JDE',
        dataIndex: 'mainJdeCode',
        key: 'mainJdeCode',
        width: 100,
    }, {
        title: '子JDE',
        dataIndex: 'childJdeCode',
        key: 'childJdeCode',
        width: 100,
    }, {
        title: 'JDE是否需要扣除相应金额',
        dataIndex: 'needDeductAmount',
        key: 'needDeductAmount',
        width: 140,
        render: text => this.renderDefault(text),
    }, {
        title: '备注及特殊要求说明',
        dataIndex: 'remarkSpecialRequest',
        key: 'remarkSpecialRequest',
        width: 160,
    }, {
        title: '需求类型',
        dataIndex: 'requirementType',
        key: 'requirementType',
        width: 100,
    }, {
        title: '业务机会名',
        dataIndex: 'businessOpportunityName',
        key: 'businessOpportunityName',
        width: 160,
    }, {
        title: '研发产品类型',
        dataIndex: 'researchProductTypeName',
        key: 'researchProductTypeName',
        width: 120,
    }, {
        title: '试验分期',
        dataIndex: 'byStageName',
        key: 'byStageName',
        width: 100,
    }, {
        title: '项目类型',
        dataIndex: 'invTypeName',
        key: 'invTypeName',
        width: 100,
    }, {
        title: '报价/合同是否标明总价',
        dataIndex: 'indicateTotalPrice',
        key: 'indicateTotalPrice',
        width: 140,
        render: text => this.renderDefault(text),
    }, {
        title: 'BA',
        dataIndex: 'baName',
        key: 'baName',
        width: 100,
        render: (text, record) => format('joint', text, record.baCode),
    }, {
        title: 'BD',
        dataIndex: 'bdName',
        key: 'bdName',
        width: 100,
        render: (text, record) => format('joint', text, record.bdCode),
    }, {
        title: '业务类型',
        dataIndex: 'businessType',
        key: 'businessType',
        width: 100,
    }, {
        title: '税率（%）',
        dataIndex: 'taxRate',
        key: 'taxRate',
        width: 90,
        render: text => format('unit', text, '%'),
    }, {
        title: '币种',
        dataIndex: 'currencyCode',
        key: 'currencyCode',
        width: 80,
    }, {
        title: '税费',
        dataIndex: 'taxAmount',
        key: 'taxAmount',
        width: 100,
        render: text => format('money', text),
    }, {
        title: 'PT费（税前费用）',
        dataIndex: 'ptFeePreTax',
        key: 'ptFeePreTax',
        width: 120,
        render: text => format('money', text),
    }, {
        title: 'PT费（税费）',
        dataIndex: 'ptFeeTax',
        key: 'ptFeeTax',
        width: 100,
        render: text => format('money', text),
    }, {
        title: 'PM',
        dataIndex: 'pmName',
        key: 'pmName',
        width: 100,
        render: (text, record) => format('joint', text, record.pmCode),
    }, {
        title: '原合同JDE',
        dataIndex: 'originContractCode',
        key: 'originContractCode',
        width: 110,
    }, {
        title: '此次CO增加/减少金额',
        dataIndex: 'coChangeAmount',
        key: 'coChangeAmount',
        width: 140,
        render: text => format('money', text),
    }, {
        title: 'JDE',
        dataIndex: 'jdeCode',
        key: 'jdeCode',
        width: 100,
    }, {
        title: '执行业务线二级分类',
        dataIndex: 'secondLineName',
        key: 'secondLineName',
        width: 140,
    }, {
        title: 'JDE建号申请状态',
        dataIndex: 'jdeApplyStatusShow',
        key: 'jdeApplyStatusShow',
        width: 140,
        render: text => this.renderJdeApplyStatus(text),
    }, {
        title: '提前上岗申请函附件',
        dataIndex: 'advanceDutyAttachmentName',
        key: 'advanceDutyAttachmentName',
        width: 140,
    }, {
        title: '终版文档附件',
        dataIndex: 'finalVersionAttachmentName',
        key: 'finalVersionAttachmentName',
        width: 130,
    }, {
        title: 'JDE建号申请单号',
        dataIndex: 'jdeApplyCode',
        key: 'jdeApplyCode',
        fixed: 'right',
        width: 120,
    }]

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        const { sortParams, searchParams } = this.state;
        const url = API_URL.contract.exportCrmContractList;
        ExportUtil.export({ ...sortParams, ...searchParams }, null, url);
        message.success(`开始导出，请在右上角“下载站”中查看导出进度，下载导出文件，请勿重复导出`);
    }

    render() {
        const { loading, pagination, sortParams, data } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='crmContractRecord' />
                <div className="main">
                    <Filter search={this.search} export={this.export} />
                    <TableC
                        loading={loading}
                        scrollY={550}
                        sortParams={sortParams}
                        pagination={pagination}
                        columns={this.getColumns()}
                        data={data}
                        onChange={this.handleTableChange}
                    />
                </div>
            </div>
        );
    }
}

export default CrmContractRecord;


// WEBPACK FOOTER //
// ./src/components/contractManagement/crmContractRecord/index.js